export const TITLE = 'Date and time';
export const SUB_TITLE = 'Check alternative dates and times using the calendar.';
export const APPOINTMENT_INFO_TITLE = 'Current engineer appointment:';
